import * as React from 'react';

function SvgSkipEnd(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M12.5 4a.5.5 0 00-1 0v3.248L5.233 3.612C4.713 3.31 4 3.655 4 4.308v7.384c0 .653.713.998 1.233.696L11.5 8.752V12a.5.5 0 001 0V4zM5 4.633L10.804 8 5 11.367V4.633z' />
		</svg>
	);
}

export default SvgSkipEnd;
